import SuggestedReason from "seneca-common/features/smart-learning/models/SuggestionReason";

export function getSuggestionReasonWeighting(suggestedReason: SuggestedReason) {
  return suggestedReason.reasonWeighting;
}

export function getSuggestionReason(suggestedReason: SuggestedReason) {
  return suggestedReason.reason;
}
